import {
  EAlgiDurumu,
  EEnvironmentalUnitType,
  EFaaliyet,
  EIstemci2DOlayTipi,
  ETaraflarArasiIliskiler,
} from 'src/enums/mixed.enum';
import { EEtmenTipi, EMesajAltTipi, EtmenDurumu } from 'src/types/components/socket.type';
import {
  AircraftStatus,
  CombinedEtmenAndCevreselEtmenGuncellemeType,
  CommDeviceStatus,
  EnvironmentalUnit,
  EtmenGuncellemeType,
  EtmenTuruGuncellemeType,
  ManifestStatus,
  MapUnit,
  NavalcraftStatus,
  ObstacleStatus,
  SupplyStatus,
  SystemStatus,
  TUnitRotaAdim,
  TBackendUpdateErrors,
  UnitCommunicationStatus,
  UnitIconGeneratorProps,
  UnitType,
  HlaMapUnit,
} from 'src/types/unit.type';
import {
  BinaTemizlemeEtkinligi,
  EngelHarbiEtkinligi,
  EtmenSavunma,
  EtmenTurununEtkinligi,
  Hacim,
  IntikaleBaslamaBitirmeSuresi,
  IntikaleEtkinlikleri,
  Konum,
} from 'src/types/mixed.type';
import { isArray, isNumber } from 'lodash';
import {
  SIDC_AIR_MISSILE_SYMBOL,
  SIDC_AIR_SYMBOL,
  SIDC_CIVILIAN_SYMBOL,
  SIDC_LAND_SYMBOL,
  SIDC_MINE_SYMBOL,
  SIDC_SUBSURFACE_SYMBOL,
  SIDC_SURFACE_SYMBOL,
} from 'src/constants/sidc.constants';
import { cevreselEtmenGenerator, generator } from 'src/app/helpers/map-unit-generator.helper';
import { EtmenResultType } from 'src/types/services/hymotsc/etmen.type';
import { TaraflarResultType } from 'src/types/services/hymotsc/taraflar.type';
import { EtmenSiniflariResultType } from 'src/types/services/hymotsc/etmen-siniflari.type';
import { EtmenTurleriResultType } from 'src/types/services/hymotsc/etmen-turleri.type';
import { EtmenTuruIkmalDurumuResultType } from 'src/types/services/hymotsc/etmen-turu-ikmal-durumu.type';
import { EtmenTuruTmkResultType } from 'src/types/services/hymotsc/etmen-turu-tmk.type';
import { EtmenTuruDenizAraciResultType } from 'src/types/services/hymotsc/etmen-turu-deniz-araci.type';
import { EtmenTuruEngelResultType } from 'src/types/services/hymotsc/etmen-turu-engel.type';
import { EtmenTuruHavaAraciResultType } from 'src/types/services/hymotsc/etmen-turu-hava-araci.type';
import { EtmenTuruMuhabereCihaziResultType } from 'src/types/services/hymotsc/etmen-turu-muhabere-cihazi.type';
import { EtmenTuruUzayAraciResultType } from 'src/types/services/hymotsc/etmen-turu-uzay-araci.type';
import { convertOlaylar } from 'src/app/helpers/content.helper';
import { CevreselEtmenResultType } from 'src/types/services/hymotsc/cevresel-etmen.type';
import { isBigInt } from 'src/app/helpers/parse-bigint.helper';
import { convertMeasurement } from './convertion.helper';
import { HLAForceIdentifierEnum } from '../components/LRC/lrc.config';
import { properTextColor } from '../utils/mapUtil';
import { preloadMilsymbol } from './milSymbol.helper';

export const defaultUnitSIDC = '10011000000000000000';

const processUnitEscapeCharCheck = (value: any, defaultValue = 0) => {
  if (value === '~') {
    return defaultValue;
  }
  return value;
};

export const senseUpdateRestrictions = {
  kisaIsim: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  uzunIsim: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  taraf: [
    EAlgiDurumu['Side Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  etmenSinifi: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  etmenTuru: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  faaliyeti: [
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  harekatSafhasi: [
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  angajmanKurali: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  ustIsletenEtmen: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  ikmalindenSorumluEtmen: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  bindirilmisMi: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Side Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  savunma: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  magicIkmal: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  insanZayiatOrani: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  otonomZayiatOrani: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  etkinlik: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Side Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  unsurDurumlari: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Side Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  ikmalDurumlari: [
    EAlgiDurumu['Prototype Identified'],
    EAlgiDurumu['Side Identified'],
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  manifesto: [
    EAlgiDurumu['Prototype and Side Identified'],
    EAlgiDurumu['Identity Identified'],
    EAlgiDurumu['Contact Loss'],
    EAlgiDurumu.Self,
  ],
  beklemeSuresi: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
  havadaBekliyorMu: [EAlgiDurumu['Identity Identified'], EAlgiDurumu['Contact Loss'], EAlgiDurumu.Self],
};

export const isEtmenTipiCevresel = (etmenTipi: number) => {
  return etmenTipi === EEtmenTipi.DENIZ_KIRLILIGI;
};

export const isOlayTipiEtmenSilme = (tip: EIstemci2DOlayTipi) => {
  return [EIstemci2DOlayTipi.SILINTI, EIstemci2DOlayTipi.BIRLESTI].includes(tip);
};

const upsertEnvUnit = (
  container: EnvironmentalUnit[],
  responseUnit: EnvironmentalUnit,
  orgEnvUnit: EnvironmentalUnit,
) => {
  const envUnit: EnvironmentalUnit = {
    ...orgEnvUnit,
    ...responseUnit,
    isUpdated: true,
    runTimeSirasindaOlusturuldu: true,
    algiDurumu: EAlgiDurumu.Self, // Backend CBRN algılaması implement edince responseUnit den gelen veriyi kullan.
  };

  upsertEnvUnitToContainer(envUnit, container);
};

const upsertUnit = (
  container: MapUnit[],
  responseUnit: EtmenGuncellemeType,
  org: MapUnit,
  prototype?: EtmenTurleriResultType,
) => {
  let { algiDurumu } = responseUnit;

  if (algiDurumu === undefined) {
    algiDurumu = EAlgiDurumu.Self;
  }

  const kisaIsim = senseUpdateRestrictions.kisaIsim.includes(algiDurumu) ? org.kisaIsimOrg : `Unknown_${org.id}`;

  const updateErrors: TBackendUpdateErrors = {
    kisaIsim,
    errors: [],
  };

  const konumSplit = responseUnit.konum.split(',');
  if (konumSplit.length < 3) updateErrors.errors.push(`Location info is invalid: ${responseUnit.konum}`);
  const konum: Konum = {
    lat: Number(konumSplit[0]),
    lng: Number(konumSplit[1]),
    alt: Number(konumSplit[2]),
  };

  const hacimSplit = responseUnit.hacim.split(',');
  if (hacimSplit.length < 3) updateErrors.errors.push(`Volume info is invalid: ${responseUnit.hacim}`);
  const hacim: Hacim = {
    genislik: Number(hacimSplit[0]),
    uzunluk: Number(hacimSplit[1]),
    yukseklik: Number(hacimSplit[2]),
  };

  let etkinlik: EtmenTurununEtkinligi | undefined;
  if (senseUpdateRestrictions.etkinlik.includes(algiDurumu)) {
    const etkinlikSplit = responseUnit.etkinlik.split(',');
    if (etkinlikSplit.length < 3) updateErrors.errors.push(`Effectiveness info is invalid: ${responseUnit.etkinlik}`);
    etkinlik = {
      disiplinVeMoralParametresi: Number(etkinlikSplit[0]),
      egitimSeviyesiParametresi: Number(etkinlikSplit[1]),
      meskunMahalParametresi: Number(etkinlikSplit[2]),
    };
  }

  let savunma: EtmenSavunma | undefined;
  if (senseUpdateRestrictions.savunma.includes(algiDurumu)) {
    const savunmaSplit = responseUnit.savunma.split(',');
    if (savunmaSplit.length < 4)
      updateErrors.errors.push(`Defense Parameters info is invalid: ${responseUnit.savunma}`);
    savunma = {
      savunmaYuzdesi: Number(savunmaSplit[0]),
      hazirlikSuresi: Number(savunmaSplit[1]),
      ortmeOyalamaSuresi: Number(savunmaSplit[2]),
      atesEdenSonEtmenId: Number(processUnitEscapeCharCheck(savunmaSplit[3])),
    };
  }

  const rota: TUnitRotaAdim[] = [];
  const rotaAdimlari = responseUnit.rota?.split('|');
  if (rotaAdimlari && isArray(rotaAdimlari) && rotaAdimlari[0] !== '' && rotaAdimlari.length) {
    rotaAdimlari.forEach((rotaAdimi) => {
      const rotaAdimiSplit = rotaAdimi.split(',');
      if (rotaAdimiSplit.length < 4) updateErrors.errors.push(`Route info is invalid ${rotaAdimi}`);
      const routeItem: TUnitRotaAdim = {
        siralama: Number(rotaAdimiSplit[0]),
        konum: {
          lat: Number(Number(rotaAdimiSplit[1]).toFixed(6)),
          lng: Number(Number(rotaAdimiSplit[2]).toFixed(6)),
          alt: Number(rotaAdimiSplit[3]),
        },
        havaKesifBolgesiMi: Number(rotaAdimiSplit[5]) === 1,
      };

      rota.push(routeItem);
    });
  }

  const kontrolBolgesi: Konum[] = [];
  const kontrolBolgesiAdimlari = responseUnit.kontrolBolgesi?.split('|');
  kontrolBolgesiAdimlari?.pop();

  if (
    kontrolBolgesiAdimlari &&
    isArray(kontrolBolgesiAdimlari) &&
    kontrolBolgesiAdimlari[0] !== '' &&
    kontrolBolgesiAdimlari.length
  ) {
    kontrolBolgesiAdimlari.forEach((kontrolBolgesiAdimi) => {
      const kontrolBolgesiAdimiSplit = kontrolBolgesiAdimi.split(',');
      if (kontrolBolgesiAdimiSplit.length < 4)
        updateErrors.errors.push(`Control Zone info is invalid ${kontrolBolgesiAdimi}`);
      const kontrolBolgesiItem: Konum = {
        lat: Number(Number(kontrolBolgesiAdimiSplit[1]).toFixed(6)),
        lng: Number(Number(kontrolBolgesiAdimiSplit[2]).toFixed(6)),
        alt: Number(kontrolBolgesiAdimiSplit[3]),
      };

      kontrolBolgesi.push(kontrolBolgesiItem);
    });
  }

  const emirKuyrugu = responseUnit.emirKuyrugu.split('|').map((value: any) => Number(value));

  const supplyStatus: SupplyStatus[] = [];
  if (senseUpdateRestrictions.ikmalDurumlari.includes(algiDurumu)) {
    const ikmalDurumlariArray = responseUnit.ikmalDurumlari.split('|');

    if (
      ikmalDurumlariArray &&
      isArray(ikmalDurumlariArray) &&
      ikmalDurumlariArray[0] !== '' &&
      ikmalDurumlariArray.length
    ) {
      ikmalDurumlariArray.forEach((ikmalDurumu) => {
        const ikmalDurumuSplit = ikmalDurumu.split(',');
        if (ikmalDurumuSplit.length < 7) updateErrors.errors.push(`Supply Status is invalid ${ikmalDurumu}`);
        const item: SupplyStatus = {
          ikmalId: Number(ikmalDurumuSplit[0]),
          currentAmount: Number(ikmalDurumuSplit[3]),
          targetAmount: Number(ikmalDurumuSplit[4]),
          autoResupply: Number(ikmalDurumuSplit[5]),
        };

        supplyStatus.push(item);
      });
    }
  }

  const systemStatus: SystemStatus[] = [];
  if (senseUpdateRestrictions.unsurDurumlari.includes(algiDurumu)) {
    const tmkDurumlariArray = responseUnit.unsurTMK.split('|');

    if (tmkDurumlariArray && isArray(tmkDurumlariArray) && tmkDurumlariArray[0] !== '' && tmkDurumlariArray.length) {
      tmkDurumlariArray.forEach((tmkDurumu) => {
        const tmkDurumuSplit = tmkDurumu.split(',');
        if (tmkDurumuSplit.length < 8) updateErrors.errors.push(`System Status is invalid ${tmkDurumu}`);
        const item: SystemStatus = {
          tmkId: Number(tmkDurumuSplit[0]),
          currentAmount: Number(tmkDurumuSplit[1]),
          wounded: Number(tmkDurumuSplit[2]),
          kbrnEtkisinde: Number(tmkDurumuSplit[3]),
          karistirilmis: Number(tmkDurumuSplit[4]),
          casualty: Number(tmkDurumuSplit[5]),
          // 6. indeks birim maliyet
          // 7. kisa isim

          unsurAktif: Number(tmkDurumuSplit[8]),
          // 9. kategori
        };

        systemStatus.push(item);
      });
    }
  }

  const navalcraftsStatus: NavalcraftStatus[] = [];
  if (senseUpdateRestrictions.unsurDurumlari.includes(algiDurumu)) {
    const denizAraciDurumlariArray = responseUnit.unsurDenizAraci.split('|');

    if (
      denizAraciDurumlariArray &&
      isArray(denizAraciDurumlariArray) &&
      denizAraciDurumlariArray[0] !== '' &&
      denizAraciDurumlariArray.length
    ) {
      denizAraciDurumlariArray.forEach((denizAraciDurumu) => {
        const denizAraciDurumuSplit = denizAraciDurumu.split(',');
        if (denizAraciDurumuSplit.length < 11)
          updateErrors.errors.push(`Navalcraft Status is invalid ${denizAraciDurumu}`);
        const item: NavalcraftStatus = {
          denizAraciId: Number(denizAraciDurumuSplit[0]),
          currentAmount: Number(denizAraciDurumuSplit[1]),
          wounded: Number(denizAraciDurumuSplit[2]),
          kbrnEtkisinde: Number(denizAraciDurumuSplit[3]),
          karistirilmis: Number(denizAraciDurumuSplit[4]),
          casualty: Number(denizAraciDurumuSplit[5]),
          // 6. indeks birim maliyet
          // 7. kisa isim

          unsurAktif: Number(denizAraciDurumuSplit[8]),

          // 9. kategori

          suDolanKompartimanSayisi: Number(denizAraciDurumuSplit[10]),
          kompartimanSayisi: Number(denizAraciDurumuSplit[11]),
        };

        navalcraftsStatus.push(item);
      });
    }
  }

  const aircraftsStatus: AircraftStatus[] = [];
  if (senseUpdateRestrictions.unsurDurumlari.includes(algiDurumu)) {
    const havaAraciDurumlariArray = responseUnit.unsurHavaAraci.split('|');

    if (
      havaAraciDurumlariArray &&
      isArray(havaAraciDurumlariArray) &&
      havaAraciDurumlariArray[0] !== '' &&
      havaAraciDurumlariArray.length
    ) {
      havaAraciDurumlariArray.forEach((havaAraciDurumu) => {
        const havaAraciDurumuSplit = havaAraciDurumu.split(',');
        if (havaAraciDurumuSplit.length < 8) updateErrors.errors.push(`Aircraft Status is invalid ${havaAraciDurumu}`);
        const item: AircraftStatus = {
          havaAraciId: Number(havaAraciDurumuSplit[0]),
          currentAmount: Number(havaAraciDurumuSplit[1]),
          wounded: Number(havaAraciDurumuSplit[2]),
          kbrnEtkisinde: Number(havaAraciDurumuSplit[3]),
          karistirilmis: Number(havaAraciDurumuSplit[4]),
          casualty: Number(havaAraciDurumuSplit[5]),
          // 6. indeks birim maliyet
          // 7. kisa isim

          unsurAktif: Number(havaAraciDurumuSplit[8]),

          // 9. kategori
        };

        aircraftsStatus.push(item);
      });
    }
  }

  const obstaclesStatus: ObstacleStatus[] = [];
  if (senseUpdateRestrictions.unsurDurumlari.includes(algiDurumu)) {
    const insanYapimiEngelDurumlariArray = responseUnit.unsurInsanYapimiEngel.split('|');

    if (
      insanYapimiEngelDurumlariArray &&
      isArray(insanYapimiEngelDurumlariArray) &&
      insanYapimiEngelDurumlariArray[0] !== '' &&
      insanYapimiEngelDurumlariArray.length
    ) {
      insanYapimiEngelDurumlariArray.forEach((insanYapimiEngelDurumu) => {
        const insanYapimiEngelDurumuSplit = insanYapimiEngelDurumu.split(',');
        if (insanYapimiEngelDurumuSplit.length < 13)
          updateErrors.errors.push(`Obstacle Status is invalid ${insanYapimiEngelDurumu}`);
        const item: ObstacleStatus = {
          engelId: Number(insanYapimiEngelDurumuSplit[0]),
          currentAmount: Number(insanYapimiEngelDurumuSplit[1]),
          wounded: Number(insanYapimiEngelDurumuSplit[2]),
          kbrnEtkisinde: Number(insanYapimiEngelDurumuSplit[3]),
          karistirilmis: Number(insanYapimiEngelDurumuSplit[4]),
          casualty: Number(insanYapimiEngelDurumuSplit[5]),

          // 6. indeks birim maliyet
          // 7. kisa isim

          unsurAktif: Number(insanYapimiEngelDurumuSplit[8]),

          // 9. kategori

          engelMevcutlari: {
            antiPersonelMiktari: Number(insanYapimiEngelDurumuSplit[10]),
            antiAracMiktari: Number(insanYapimiEngelDurumuSplit[11]),
            antiZirhliMiktari: Number(insanYapimiEngelDurumuSplit[12]),
            AntiIndirmeCikartmaMiktari: Number(insanYapimiEngelDurumuSplit[13]),
          },
        };

        obstaclesStatus.push(item);
      });
    }
  }

  const commDevicesStatus: CommDeviceStatus[] = [];
  if (senseUpdateRestrictions.unsurDurumlari.includes(algiDurumu)) {
    const muhabereCihaziDurumlariArray = responseUnit.unsurMuhabereCihazi.split('|');

    if (
      muhabereCihaziDurumlariArray &&
      isArray(muhabereCihaziDurumlariArray) &&
      muhabereCihaziDurumlariArray[0] !== '' &&
      muhabereCihaziDurumlariArray.length
    ) {
      muhabereCihaziDurumlariArray.forEach((muhabereCihaziDurumu) => {
        const muhabereCihaziDurumuSplit = muhabereCihaziDurumu.split(',');
        if (muhabereCihaziDurumuSplit.length < 8)
          updateErrors.errors.push(`Communication Device Status is invalid ${muhabereCihaziDurumu}`);
        const item: CommDeviceStatus = {
          muhabereCihaziId: Number(muhabereCihaziDurumuSplit[0]),
          currentAmount: Number(muhabereCihaziDurumuSplit[1]),
          wounded: Number(muhabereCihaziDurumuSplit[2]),
          kbrnEtkisinde: Number(muhabereCihaziDurumuSplit[3]),
          karistirilmis: Number(muhabereCihaziDurumuSplit[4]),
          casualty: Number(muhabereCihaziDurumuSplit[5]),

          // 6. indeks birim maliyet
          // 7. kisa isim

          unsurAktif: Number(muhabereCihaziDurumuSplit[8]),

          // 9. kategori
        };

        commDevicesStatus.push(item);
      });
    }
  }

  const manifesto: ManifestStatus[] = [];
  if (senseUpdateRestrictions.manifesto.includes(algiDurumu)) {
    const manifestoDurumlariArray = responseUnit.manifesto.split('|');

    if (
      manifestoDurumlariArray &&
      isArray(manifestoDurumlariArray) &&
      manifestoDurumlariArray[0] !== '' &&
      manifestoDurumlariArray.length
    ) {
      manifestoDurumlariArray.forEach((manifestoDurumu) => {
        const manifestoDurumuSplit = manifestoDurumu.split(',');
        if (manifestoDurumuSplit.length < 3) updateErrors.errors.push(`Manifest Status is invalid ${manifestoDurumu}`);
        const item: ManifestStatus = {
          tasinanEtmenId: isBigInt(manifestoDurumuSplit[0])
            ? BigInt(manifestoDurumuSplit[0])
            : Number(manifestoDurumuSplit[0]),
          gizlilikDerecesi: Number(manifestoDurumuSplit[1]),
          tasimaTipi: Number(manifestoDurumuSplit[2]),
        };
        manifesto.push(item);
      });
    }
  }
  const muhabereVektörü: UnitCommunicationStatus[] = [];
  const muhabereVektörüArray = responseUnit.muhabereKuruluOlanEtmenler.split('|');

  if (
    muhabereVektörüArray &&
    isArray(muhabereVektörüArray) &&
    muhabereVektörüArray[0] !== '' &&
    muhabereVektörüArray.length
  ) {
    muhabereVektörüArray.forEach((muhabereVektörüStr) => {
      const muhabereVektörüSplit = muhabereVektörüStr.split(',');
      if (muhabereVektörüSplit.length < 2)
        updateErrors.errors.push(`Communication Network Info is invalid ${muhabereVektörüStr}`);
      const item: UnitCommunicationStatus = {
        etmenVtId: isBigInt(muhabereVektörüSplit[0])
          ? BigInt(muhabereVektörüSplit[0])
          : Number(muhabereVektörüSplit[0]),
        gecikme: Number(muhabereVektörüSplit[1]),
      };

      muhabereVektörü.push(item);
    });
  }

  const muhabereKaraListe = responseUnit.muhabereKaraListe.split('|').map((value: any) => Number(value));

  const unit = {
    ...org,
    isUpdated: true,
    algiDurumu,
    sonBilinenAlgiDurumu: responseUnit.sonBilinenAlgiDurumu,

    // #region Sabitler
    kisaIsim,
    uzunIsim: senseUpdateRestrictions.uzunIsim.includes(algiDurumu) ? org.uzunIsimOrg : `Unknown`,
    etmenTuru: senseUpdateRestrictions.etmenTuru.includes(algiDurumu)
      ? prototype
        ? {
            id: prototype.id,
            kisaIsim: prototype.kisaIsim,
            uzunIsim: prototype.uzunIsim,
            sembolu: prototype.sembolu,
            buyuklugu: prototype.buyuklugu,
            sidc: prototype.sidc,
          }
        : { ...org.etmenTuruOrg }
      : undefined,
    etmenSinifi: senseUpdateRestrictions.etmenSinifi.includes(algiDurumu) ? { ...org.etmenSinifiOrg } : undefined,
    taraf: senseUpdateRestrictions.taraf.includes(algiDurumu) ? { ...org.tarafOrg } : undefined,
    sidc: responseUnit?.sidc || '',
    // #endregion

    // #region Her zaman güncelle
    konum,
    istikamet: responseUnit.istikametAcisi,
    hiz: responseUnit.hiz,
    hacim,
    etmenAktiflikDurumu: responseUnit.etmenAktiflikDurumu,
    // #endregion

    // #region Algı güncellemeler
    harekatSafhasi: senseUpdateRestrictions.harekatSafhasi.includes(algiDurumu)
      ? responseUnit.harekatSafhasi
      : undefined,
    faaliyeti: senseUpdateRestrictions.faaliyeti.includes(algiDurumu) ? responseUnit.faaliyet : undefined,
    magicIkmal: senseUpdateRestrictions.magicIkmal.includes(algiDurumu) ? responseUnit.magicIkmal : undefined,
    beklemeSuresi: senseUpdateRestrictions.beklemeSuresi.includes(algiDurumu) ? responseUnit.beklemeSuresi : undefined,
    havadaBekliyorMu: senseUpdateRestrictions.havadaBekliyorMu.includes(algiDurumu)
      ? responseUnit.havadaBekliyorMu
      : undefined,
    insanZayiatOrani: senseUpdateRestrictions.insanZayiatOrani.includes(algiDurumu)
      ? responseUnit.insanZayiatOrani || 0
      : undefined,
    otonomZayiatOrani: senseUpdateRestrictions.otonomZayiatOrani.includes(algiDurumu)
      ? responseUnit.otonomZayiatOrani || 0
      : undefined,

    supplyStatus,
    systemStatus,
    navalcraftsStatus,
    aircraftsStatus,
    obstaclesStatus,
    commDevicesStatus,

    angajmanKurali: senseUpdateRestrictions.angajmanKurali.includes(algiDurumu)
      ? responseUnit.angajmanKurali
      : undefined,
    ustIsletenEtmenVtId: senseUpdateRestrictions.ustIsletenEtmen.includes(algiDurumu)
      ? isBigInt(responseUnit.ustIsletenEtmenVtId)
        ? BigInt(responseUnit.ustIsletenEtmenVtId || 0)
        : Number(responseUnit.ustIsletenEtmenVtId)
      : undefined,
    ikmalindenSorumluEtmenVtId: senseUpdateRestrictions.ikmalindenSorumluEtmen.includes(algiDurumu)
      ? isBigInt(responseUnit.ikmalindenSorumluEtmenVtId)
        ? BigInt(responseUnit.ikmalindenSorumluEtmenVtId || 0)
        : Number(responseUnit.ikmalindenSorumluEtmenVtId)
      : undefined,

    etkinlik,
    bindirilmisMi: senseUpdateRestrictions.bindirilmisMi.includes(algiDurumu) ? responseUnit.bindirilmisMi : undefined,
    manifesto,
    savunma,
    // #endregion

    // #region Kararsızlar
    rota,
    rotaSirasi: responseUnit.rotaSirasi || 0,
    rotaBolgeMi: responseUnit.rotaBolgeMi,

    kontrolBolgesi,

    emirler: responseUnit.emirler,
    emirKuyrugu,
    // #endregion

    // #region  Alakasızlar
    isActive: true,
    eklentiId: responseUnit.eklentiId,
    aisDurumu: responseUnit.aisStatus,
    etmenTipi: responseUnit.etmenTipi,
    etmenKontrolcusu: responseUnit.etmenKontrolcusu,
    // #endregion

    muhabereVektörü,
    muhabereKaraListe,
  };

  upsertUnitToContainer(unit, container);
};

const upsertUnitToContainer = (unit: MapUnit, container: MapUnit[]) => {
  const index = container.findIndex((o) => o.id === unit.id);
  if (index >= 0) {
    // eslint-disable-next-line no-param-reassign
    container[index] = unit;
  } else {
    container.push(unit);
  }
};

const upsertEnvUnitToContainer = (unit: EnvironmentalUnit, container: EnvironmentalUnit[]) => {
  const index = container.findIndex((o) => o.id === unit.id);
  if (index >= 0) {
    // eslint-disable-next-line no-param-reassign
    container[index] = unit;
  } else {
    container.push(unit);
  }
};

export const convertToBinaryChecker = (binaryString: string) => {
  let updatedString = binaryString;
  while (updatedString.length < 8) {
    updatedString += '0';
  }
  return updatedString;
};

export const processUnits = (
  responseUnits: CombinedEtmenAndCevreselEtmenGuncellemeType[],
  orgUnits: MapUnit[],
  orgEnvironmentalUnits: EnvironmentalUnit[],
  etmenTurleri: EtmenTurleriResultType[],
  etmenSiniflari: EtmenSiniflariResultType[],
  taraflar: TaraflarResultType[],
  mesajAltTipi?: EMesajAltTipi,
  olaylarStr?: string,
) => {
  const olaylarErrors: string[] = [];
  const olaylar = olaylarStr ? convertOlaylar(olaylarStr, olaylarErrors) : undefined;

  if (olaylarErrors.length) {
    // eslint-disable-next-line no-console
    console.error('Failed to read Olaylar: ', olaylarErrors);
  }

  let toBeDeleted: (number | bigint)[] = [];

  const updatedUnits: MapUnit[] = [
    ...orgUnits.map((o) => {
      return {
        ...o,
        isUpdated: mesajAltTipi === EMesajAltTipi.SIMULASYON_TANITIM_GUNCELLEMESI_2D,
        algiDurumu:
          mesajAltTipi === EMesajAltTipi.SIMULASYON_TANITIM_GUNCELLEMESI_2D
            ? EAlgiDurumu['Not Detected or Identified']
            : o.algiDurumu,
      };
    }),
  ];

  const updatedEnvironmentalUnits: EnvironmentalUnit[] =
    mesajAltTipi === EMesajAltTipi.SIMULASYON_DURUM_GUNCELLEMESI_2D
      ? [
          ...orgEnvironmentalUnits.map((o) => {
            return {
              ...o,
              isUpdated: false,
            };
          }),
        ]
      : [];

  const toBeDeletedOlaylar = olaylar?.filter((olay) => isOlayTipiEtmenSilme(olay.tip)).map((olay) => olay.ozneId);

  if (toBeDeletedOlaylar) {
    toBeDeleted = [...toBeDeleted, ...toBeDeletedOlaylar];
  }

  for (const unitFromBackend of responseUnits) {
    // #region Cevresel Etmen Update or Delete

    if (isEtmenTipiCevresel(unitFromBackend.etmenTipi)) {
      let konum: Konum;
      if (typeof unitFromBackend.konum === 'string') {
        const konumSplit = unitFromBackend.konum.split(',');
        if (konumSplit.length < 3) {
          // updateErrors.errors.push(`Location info is invalid: ${unitFromBackend.konum}`);
          konum = {
            lat: 0,
            lng: 0,
            alt: undefined,
          };
        }
        konum = {
          lat: Number(konumSplit[0]),
          lng: Number(konumSplit[1]),
          alt: Number(konumSplit[2]),
        };
      } else {
        konum = unitFromBackend.konum;
      }
      const responseUnit = { ...unitFromBackend, konum } as EnvironmentalUnit;
      const org = orgEnvironmentalUnits.find((o) => o.id === unitFromBackend.vtId);

      if (org) {
        let envUnit;
        if (toBeDeleted && toBeDeleted.includes(org.id)) {
          envUnit = { ...org, algiDurumu: EAlgiDurumu['Not Detected or Identified'] };
          continue;
        } else {
          let { algiDurumu } = responseUnit;

          if (algiDurumu === undefined) {
            algiDurumu = EAlgiDurumu.Self;
          }
          envUnit = { ...org, algiDurumu: EAlgiDurumu['Not Detected or Identified'] };
        }
        upsertEnvUnit(updatedEnvironmentalUnits, responseUnit, envUnit);
      } else {
        const cevreselEtmen: CevreselEtmenResultType = {
          id: responseUnit.vtId,
          konum: responseUnit.konum,
          tipi: responseUnit.tipi,
          yaricap: responseUnit.tipi === EEnvironmentalUnitType.CIRCLE ? responseUnit.yaricap || 0 : 0,
          disYaricap:
            responseUnit.tipi === EEnvironmentalUnitType.CIRCLE
              ? responseUnit.disYaricap || responseUnit.yaricap || 0
              : 0,
          aci: responseUnit.tipi === EEnvironmentalUnitType.CIRCLE ? responseUnit.aci || 0 : 0,
          istikamet: responseUnit.tipi === EEnvironmentalUnitType.CIRCLE ? responseUnit.istikamet || 0 : 0,
          eklentiId: responseUnit.eklentiId,
          poligon: responseUnit.tipi === EEnvironmentalUnitType.POLYGON ? responseUnit.latlngs || [] : [],
          vtId: responseUnit.vtId,
          etmenTipi: responseUnit.etmenTipi,
          kisaIsim: responseUnit.kisaIsim,
        };

        const envUnit = cevreselEtmenGenerator(cevreselEtmen);

        if (envUnit) {
          upsertEnvUnit(updatedEnvironmentalUnits, responseUnit, envUnit);
        }
      }
      // #endregion
    } else {
      const responseUnit = unitFromBackend as EtmenGuncellemeType;
      const org = orgUnits.find((o) => o.id === unitFromBackend.vtId);

      if (org) {
        if (toBeDeleted && toBeDeleted.includes(org.id)) {
          const unit = {
            ...org,
            algiDurumu: EAlgiDurumu['Not Detected or Identified'],
          };
          upsertUnitToContainer(unit, updatedUnits);
          continue;
        } else if (
          responseUnit.algiDurumu === EAlgiDurumu['Contact Loss'] &&
          mesajAltTipi === EMesajAltTipi.SIMULASYON_DURUM_GUNCELLEMESI_2D
        ) {
          const unit = { ...org, algiDurumu: responseUnit.algiDurumu, isUpdated: true };
          upsertUnitToContainer(unit, updatedUnits);
        } else {
          const foundEtmenTuru = etmenTurleri.find((o) => o.id === responseUnit.etmenTuruVtId);
          upsertUnit(updatedUnits, responseUnit, org, foundEtmenTuru);
        }
      } else {
        const etmen: EtmenResultType = {
          id: responseUnit.vtId,
          kisaIsim: responseUnit.kisaIsim,
          uzunIsim: responseUnit.uzunIsim,
          etmenTuruId: responseUnit.etmenTuruVtId,
          etmeninSimulasyonaKatilacagiZaman: 0,
          mapActive: true,
          createdAtSimulation: responseUnit.runTimeSirasindaOlusturuldu,

          magicIkmal: false,
          beklemeSuresi: 0,
          havadaBekliyorMu: false,
          eklentiId: 0,
          etmenAktiflikDurumu: 0,
          etmenTipi: 0,
          aisDurumu: false,
          etmenKontrolcusu: responseUnit.etmenKontrolcusu,
          sonBilinenAlgiDurumu: responseUnit.sonBilinenAlgiDurumu,

          konum: {
            lat: 0,
            lng: 0,
            alt: undefined,
          },
          hacim: {
            uzunluk: 0,
            genislik: 0,
            yukseklik: 0,
          },
          hiz: 0,
          istikamet: 0,
          faaliyeti: EFaaliyet.GUNLUK,
        };
        const unit = generator(etmen, etmenTurleri, etmenSiniflari, taraflar, []);

        if (unit) {
          upsertUnit(updatedUnits, responseUnit, unit);
        }
      }
    }
  }

  return {
    updatedUnits,
    updatedEnvironmentalUnits,
    toBeDeleted,
  };
};

export const processPrototypes = (
  responsePrototypes: EtmenTuruGuncellemeType[],
  orgPrototypes: EtmenTurleriResultType[],
  isAARCheck?: boolean,
) => {
  const newPrototypes: EtmenTurleriResultType[] = [];

  for (const responsePrototype of responsePrototypes) {
    const existing = !isAARCheck ? orgPrototypes.find((o) => o.id === responsePrototype.etmenTuruVtId) : undefined;

    try {
      if (!existing) {
        const updateErrors: TBackendUpdateErrors = {
          kisaIsim: responsePrototype.etmenTuruKisaIsim,
          errors: [],
        };

        const niteligiSplit = responsePrototype.nitelik
          .split(',')
          .flatMap((o) => (isNumber(Number(o)) ? Number(o).toString(2).split('') : o));

        if (niteligiSplit.length < 5) {
          niteligiSplit.unshift('0');
        }

        const engelHarbiEtkinligiSplit = responsePrototype.engelHarbiEtkinligi.split(',');
        if (engelHarbiEtkinligiSplit.length < 7)
          updateErrors.errors.push(`Engel Harbi Etkinliği info is invalid: ${responsePrototype.engelHarbiEtkinligi}`);
        const engelHarbiEtkinligi: EngelHarbiEtkinligi = {
          engelDosemeYetenegi: !!Number(engelHarbiEtkinligiSplit[0]),
          mayinDosemeSaatSuresi: Number(engelHarbiEtkinligiSplit[1]),
          elYapimiPatlayiciSaatSuresi: Number(engelHarbiEtkinligiSplit[2]),
          hendekManiaSaatSuresi: Number(engelHarbiEtkinligiSplit[3]),
          telDosemeSaatSuresi: Number(engelHarbiEtkinligiSplit[4]),
          mayinPatlatmaOlasiligi: Number(engelHarbiEtkinligiSplit[5]),
          eypPatlatmaOlasiligi: Number(engelHarbiEtkinligiSplit[6]),
        };

        const binaTemizlemeEtkinligiParametreleriSplit =
          responsePrototype.binaTemizlemeEtkinligiParametreleri.split(',');
        if (binaTemizlemeEtkinligiParametreleriSplit.length < 2)
          updateErrors.errors.push(
            `Bina Temizleme Etkinliği info is invalid: ${responsePrototype.binaTemizlemeEtkinligiParametreleri}`,
          );
        const binaTemizlemeEtkinligiParametreleri: BinaTemizlemeEtkinligi = {
          timSayisi: Number(binaTemizlemeEtkinligiParametreleriSplit[0]),
          arindirmaHizi: Number(binaTemizlemeEtkinligiParametreleriSplit[1]),
        };

        const intikaleBaslamaSuresiSplit = responsePrototype.intikaleBaslamaSuresi.split(',');
        if (intikaleBaslamaSuresiSplit.length < 8)
          updateErrors.errors.push(`Intikale Baslama info is invalid: ${responsePrototype.intikaleBaslamaSuresi}`);
        const intikaleBaslamaSuresi: IntikaleBaslamaBitirmeSuresi = {
          taktikYollardanGizli: Number(intikaleBaslamaSuresiSplit[0]),
          taktikYollardanAcik: Number(intikaleBaslamaSuresiSplit[1]),
          taktikArazidenGizli: Number(intikaleBaslamaSuresiSplit[2]),
          taktikArazidenAcik: Number(intikaleBaslamaSuresiSplit[3]),
          idariYollardanGizli: Number(intikaleBaslamaSuresiSplit[4]),
          idariYollardanAcik: Number(intikaleBaslamaSuresiSplit[5]),
          idariArazidenGizli: Number(intikaleBaslamaSuresiSplit[6]),
          idariArazidenAcik: Number(intikaleBaslamaSuresiSplit[7]),
        };

        const intikalBitirmeSuresiSplit = responsePrototype.intikalBitirmeSuresi.split(',');
        if (intikalBitirmeSuresiSplit.length < 8)
          updateErrors.errors.push(`Intikal Bitirme info is invalid: ${responsePrototype.intikalBitirmeSuresi}`);
        const intikalBitirmeSuresi: IntikaleBaslamaBitirmeSuresi = {
          taktikYollardanGizli: Number(intikalBitirmeSuresiSplit[0]),
          taktikYollardanAcik: Number(intikalBitirmeSuresiSplit[1]),
          taktikArazidenGizli: Number(intikalBitirmeSuresiSplit[2]),
          taktikArazidenAcik: Number(intikalBitirmeSuresiSplit[3]),
          idariYollardanGizli: Number(intikalBitirmeSuresiSplit[4]),
          idariYollardanAcik: Number(intikalBitirmeSuresiSplit[5]),
          idariArazidenGizli: Number(intikalBitirmeSuresiSplit[6]),
          idariArazidenAcik: Number(intikalBitirmeSuresiSplit[7]),
        };

        const intikaleEtkinlikleriSplit = responsePrototype.intikaleEtkinlikleri.split(',');
        if (intikaleEtkinlikleriSplit.length < 2)
          updateErrors.errors.push(`Intikale Etkinlikleri info is invalid: ${responsePrototype.intikaleEtkinlikleri}`);
        const intikaleEtkinlikleri: IntikaleEtkinlikleri = {
          taktikIntikalCarpani: Number(intikaleEtkinlikleriSplit[0]),
          gizliIntikalCarpani: Number(intikaleEtkinlikleriSplit[1]),
        };

        const etmenTurununEtkinligiSplit = responsePrototype.etmenTurununEtkinligi.split(',');
        if (etmenTurununEtkinligiSplit.length < 3)
          updateErrors.errors.push(
            `Etmen Turunun Etkinliği info is invalid: ${responsePrototype.etmenTurununEtkinligi}`,
          );
        const etmenTurununEtkinligi: EtmenTurununEtkinligi = {
          disiplinVeMoralParametresi: Number(etmenTurununEtkinligiSplit[0]),
          egitimSeviyesiParametresi: Number(etmenTurununEtkinligiSplit[1]),
          meskunMahalParametresi: Number(etmenTurununEtkinligiSplit[2]),
        };

        const supplyStatus: EtmenTuruIkmalDurumuResultType[] = [];
        const ikmalDurumlariArray = responsePrototype.ikmalDurumlari.split('|');

        if (
          ikmalDurumlariArray &&
          isArray(ikmalDurumlariArray) &&
          ikmalDurumlariArray[0] !== '' &&
          ikmalDurumlariArray.length
        ) {
          ikmalDurumlariArray.forEach((ikmalDurumu) => {
            const ikmalDurumuSplit = ikmalDurumu.split(',');
            if (ikmalDurumuSplit.length < 4) updateErrors.errors.push(`Supply Status is invalid ${ikmalDurumu}`);
            const item: EtmenTuruIkmalDurumuResultType = {
              ikmalId: Number(ikmalDurumuSplit[0]),
              mevcut: Number(ikmalDurumuSplit[3]),
              hedefSeviye: Number(ikmalDurumuSplit[4]),
              otomatikYenidenIkmalSeviyesi: Number(ikmalDurumuSplit[5]),
              id: 0,
              etmenTuruId: 0,
            };

            supplyStatus.push(item);
          });
        }

        const systemStatus: EtmenTuruTmkResultType[] = [];
        const tmkDurumlariArray = responsePrototype.tmkDurumlari.split('|');

        if (
          tmkDurumlariArray &&
          isArray(tmkDurumlariArray) &&
          tmkDurumlariArray[0] !== '' &&
          tmkDurumlariArray.length
        ) {
          tmkDurumlariArray.forEach((tmkDurumu) => {
            const tmkDurumuSplit = tmkDurumu.split(',');
            if (tmkDurumuSplit.length < 2) updateErrors.errors.push(`System Status is invalid ${tmkDurumu}`);
            const item: EtmenTuruTmkResultType = {
              tmkId: Number(tmkDurumuSplit[0]),
              toplamKadro: Number(tmkDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            systemStatus.push(item);
          });
        }

        const navalcraftsStatus: EtmenTuruDenizAraciResultType[] = [];
        const denizAraciDurumlariArray = responsePrototype.denizAraclari.split('|');

        if (
          denizAraciDurumlariArray &&
          isArray(denizAraciDurumlariArray) &&
          denizAraciDurumlariArray[0] !== '' &&
          denizAraciDurumlariArray.length
        ) {
          denizAraciDurumlariArray.forEach((denizAraciDurumu) => {
            const denizAraciDurumuSplit = denizAraciDurumu.split(',');
            if (denizAraciDurumuSplit.length < 2)
              updateErrors.errors.push(`Navalcraft Status is invalid ${denizAraciDurumu}`);
            const item: EtmenTuruDenizAraciResultType = {
              denizAraciId: Number(denizAraciDurumuSplit[0]),
              miktar: Number(denizAraciDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            navalcraftsStatus.push(item);
          });
        }

        const aircraftsStatus: EtmenTuruHavaAraciResultType[] = [];
        const havaAraciDurumlariArray = responsePrototype.havaAraclari.split('|');

        if (
          havaAraciDurumlariArray &&
          isArray(havaAraciDurumlariArray) &&
          havaAraciDurumlariArray[0] !== '' &&
          havaAraciDurumlariArray.length
        ) {
          havaAraciDurumlariArray.forEach((havaAraciDurumu) => {
            const havaAraciDurumuSplit = havaAraciDurumu.split(',');
            if (havaAraciDurumuSplit.length < 2)
              updateErrors.errors.push(`Aircraft Status is invalid ${havaAraciDurumu}`);
            const item: EtmenTuruHavaAraciResultType = {
              havaAraciId: Number(havaAraciDurumuSplit[0]),
              miktar: Number(havaAraciDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            aircraftsStatus.push(item);
          });
        }

        const obstaclesStatus: EtmenTuruEngelResultType[] = [];
        const insanYapimiEngelDurumlariArray = responsePrototype.engeller.split('|');

        if (
          insanYapimiEngelDurumlariArray &&
          isArray(insanYapimiEngelDurumlariArray) &&
          insanYapimiEngelDurumlariArray[0] !== '' &&
          insanYapimiEngelDurumlariArray.length
        ) {
          insanYapimiEngelDurumlariArray.forEach((insanYapimiEngelDurumu) => {
            const insanYapimiEngelDurumuSplit = insanYapimiEngelDurumu.split(',');
            if (insanYapimiEngelDurumuSplit.length < 2)
              updateErrors.errors.push(`Obstacle Status is invalid ${insanYapimiEngelDurumu}`);
            const item: EtmenTuruEngelResultType = {
              engelId: Number(insanYapimiEngelDurumuSplit[0]),
              miktar: Number(insanYapimiEngelDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            obstaclesStatus.push(item);
          });
        }

        const commDevicesStatus: EtmenTuruMuhabereCihaziResultType[] = [];
        const muhabereCihaziDurumlariArray = responsePrototype.muhabereCihazlari.split('|');

        if (
          muhabereCihaziDurumlariArray &&
          isArray(muhabereCihaziDurumlariArray) &&
          muhabereCihaziDurumlariArray[0] !== '' &&
          muhabereCihaziDurumlariArray.length
        ) {
          muhabereCihaziDurumlariArray.forEach((muhabereCihaziDurumu) => {
            const muhabereCihaziDurumuSplit = muhabereCihaziDurumu.split(',');
            if (muhabereCihaziDurumuSplit.length < 2)
              updateErrors.errors.push(`Communication Device Status is invalid ${muhabereCihaziDurumu}`);
            const item: EtmenTuruMuhabereCihaziResultType = {
              muhabereCihaziId: Number(muhabereCihaziDurumuSplit[0]),
              miktar: Number(muhabereCihaziDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            commDevicesStatus.push(item);
          });
        }

        const spacecraftStatus: EtmenTuruUzayAraciResultType[] = [];
        const uzayAraciDurumlariArray = responsePrototype.uzayAraclari.split('|');

        if (
          uzayAraciDurumlariArray &&
          isArray(uzayAraciDurumlariArray) &&
          uzayAraciDurumlariArray[0] !== '' &&
          uzayAraciDurumlariArray.length
        ) {
          uzayAraciDurumlariArray.forEach((muhabereCihaziDurumu) => {
            const uzayAraciDurumuSplit = muhabereCihaziDurumu.split(',');
            if (uzayAraciDurumuSplit.length < 2)
              updateErrors.errors.push(`Spacecraft Status is invalid ${muhabereCihaziDurumu}`);
            const item: EtmenTuruUzayAraciResultType = {
              uzayAraciId: Number(uzayAraciDurumuSplit[0]),
              miktar: Number(uzayAraciDurumuSplit[1]),
              id: 0,
              etmenTuruId: 0,
            };

            spacecraftStatus.push(item);
          });
        }

        const hacimSplit = responsePrototype.hacim.split(',');
        if (hacimSplit.length < 3) updateErrors.errors.push(`Volume info is invalid: ${responsePrototype.hacim}`);
        const hacim: Hacim = {
          genislik: Number(hacimSplit[0]),
          uzunluk: Number(hacimSplit[1]),
          yukseklik: Number(hacimSplit[2]),
        };

        const etmenTuru: EtmenTurleriResultType = {
          id: responsePrototype.etmenTuruVtId,
          createdAtSimulation: true,
          kisaIsim: responsePrototype.etmenTuruKisaIsim,
          uzunIsim: responsePrototype.etmenTuruUzunIsim,
          etmenSinifiId: responsePrototype.etmenSinifiVtId,
          sembolu: responsePrototype.sembolu,
          buyuklugu: responsePrototype.buyuklugu,
          niteligi: parseInt(convertToBinaryChecker(niteligiSplit.join('')), 2),
          sidc: responsePrototype.sidc,
          engelHarbiEtkinligi,
          binaTemizlemeEtkinligiParametreleri,
          intikaleBaslamaSuresi,
          intikalBitirmeSuresi,
          intikaleEtkinlikleri,
          etmenTurununEtkinligi,
          hacim,
          ikmalDurumlari: supplyStatus,
          tmkDurumlari: systemStatus,
          denizAraclari: navalcraftsStatus,
          engeller: obstaclesStatus,
          havaAraclari: aircraftsStatus,
          muhabereCihazlari: commDevicesStatus,
          uzayAraclari: spacecraftStatus,
        };

        newPrototypes.push(etmenTuru);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Failed to create new prototype: `, error);
    }
  }

  return { newPrototypes };
};

const checkSIDCForStatus = (sidc: string, isDamaged: boolean, isDestroyed: boolean) => {
  let sidcToReturn = sidc;

  let status = '0';

  if (isDamaged) {
    status = '3';
  }

  if (isDestroyed) {
    status = '4';
  }

  sidcToReturn = `${sidc.slice(0, 6)}${status}${sidc.slice(7)}`;

  return sidcToReturn;
};

const getSIDCByHlaForceIdentifier = (sidc: string, forceIdentifier: number) => {
  const forceName = HLAForceIdentifierEnum[forceIdentifier];

  let standardIdentity = 4;

  // First three characters don't change
  const unusedHeader = sidc.slice(0, 3);

  // Remanining characters starting from 5th not related to this function
  const unusedFooter = sidc.slice(4);

  if (forceName.includes('FRIENDLY')) {
    standardIdentity = 3;
  } else if (forceName.includes('OPPOSING')) {
    standardIdentity = 6;
  }

  return `${unusedHeader}${standardIdentity}${unusedFooter}`;
};

const getSIDCBySense = (sidc: string, senseStatus: number, relation: ETaraflarArasiIliskiler): string => {
  let sidcToReturn = sidc;

  // First three characters don't change
  const unusedHeader = sidc.slice(0, 3);

  // Remanining characters starting from 5th not related to this function
  const unusedFooter = sidc.slice(4);

  // Fourth character changes based on relation perspective
  let standardIdentity = senseStatus === 6 ? '0' : '1';

  switch (relation) {
    case ETaraflarArasiIliskiler.ALLY:
    case ETaraflarArasiIliskiler.FRIENDLY:
    case ETaraflarArasiIliskiler.SAME:
      standardIdentity = '3';

      if (senseStatus === 6) {
        standardIdentity = '2';
      }
      break;

    case ETaraflarArasiIliskiler.SUSPICIOUS:
    case ETaraflarArasiIliskiler.ENEMY:
      standardIdentity = '6';

      if (senseStatus === 6) {
        standardIdentity = '5';
      }
      break;

    case ETaraflarArasiIliskiler.NEUTRAL:
      standardIdentity = '4';

      if (senseStatus === 6) {
        standardIdentity = '0';
      }
      break;

    default:
      break;
  }

  if (senseStatus === 2) {
    standardIdentity = '1';
  }

  if (senseStatus === 1 || senseStatus === 3) {
    sidcToReturn = defaultUnitSIDC;
  } else {
    sidcToReturn = `${unusedHeader}${standardIdentity}${unusedFooter}`;
  }

  return sidcToReturn;
};

export const unitSymbolGenerator = async (unit: MapUnit | HlaMapUnit, options: UnitIconGeneratorProps) => {
  const {
    size = 22,
    isForOverlappedPopup = false,
    additionalInfoBool = true,
    displayDirection = true,
    isSitrepMode = false,
    ignoreSense = false,
    relation = ETaraflarArasiIliskiler.NEUTRAL,
    ignoreRelation,
    mapVisualSettings,
  } = options;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const vis_displayNametags = !!mapVisualSettings?.displayNametags;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const vis_displayDirection = !!mapVisualSettings?.displayDirection;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const vis_displaySpeed = !!mapVisualSettings?.displaySpeed;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const vis_displayCasualityStatus = !!mapVisualSettings?.displayCasualityStatus;

  const displayInfoSection = vis_displayNametags || vis_displaySpeed;

  const name = getAgentName(unit) || '';
  name.replaceAll('/', '_');
  const istikamet = unit.istikamet || 0;
  const { hiz, etmenTuru } = unit;
  const isNaval = prototypeIsNaval(etmenTuru?.sembolu) && !isAirMissileIcon(etmenTuru?.sidc);

  const ms = await preloadMilsymbol();

  const colorMode = unit.taraf
    ? {
        Civilian: unit.taraf.rengi || '',
        Friend: unit.taraf.rengi || '',
        Hostile: unit.taraf.rengi || '',
        Neutral: unit.taraf.rengi || '',
        Unknown: unit.taraf.rengi || '',
      }
    : 'Light';

  const commonOptions = {
    size: isForOverlappedPopup ? 17 : size,
    alternateMedal: isMineIcon(unit?.etmenTuru?.sidc || defaultUnitSIDC),
    colorMode: !ignoreSense ? (unit.algiDurumu >= EAlgiDurumu['Side Identified'] ? colorMode : 'Light') : colorMode,
    strokeWidth: 6,
    engagementBar: unit.faaliyeti === EFaaliyet.HARP_ESIRI ? 'POW' : '',
  };

  const opts = isSitrepMode
    ? {
        ...commonOptions,
        direction: '',
      }
    : {
        ...commonOptions,
        uniqueDesignation: additionalInfoBool && vis_displayNametags ? name : '',
        infoSize: additionalInfoBool && displayInfoSection ? 65 : undefined,
        infoBackground: additionalInfoBool && displayInfoSection ? '#80808080' : undefined,
        direction:
          displayDirection && vis_displayDirection
            ? hiz
              ? isForOverlappedPopup
                ? ''
                : Math.round(istikamet % 360).toString()
              : ''
            : '',
        speed:
          additionalInfoBool && vis_displaySpeed
            ? `${
                isNaval
                  ? `${convertMeasurement('kphToKn', hiz).toFixed(2)} ${
                      !mapVisualSettings.maritimeSpeedUnit ? 'kn' : 'nm/h'
                    }`
                  : `${hiz.toFixed(2)} km/h`
              } `
            : '',

        additionalInformation:
          additionalInfoBool && vis_displaySpeed && isSubmarineIcon(etmenTuru?.sidc)
            ? `${
                isNaval
                  ? `${convertMeasurement('kphToKn', hiz).toFixed(2)} ${
                      !mapVisualSettings.maritimeSpeedUnit ? 'kn' : 'nm/h'
                    }`
                  : `${hiz.toFixed(2)} km/h`
              } `
            : '',
      };

  let sidc = unit?.sidc || unit.etmenTuru?.sidc || defaultUnitSIDC;

  // if (unit.unitType !== 'hla') {
  //   sidc = getSIDCBySense(
  //     sidc,
  //     ignoreSense ? EAlgiDurumu.Self : unit.algiDurumu,
  //     ignoreRelation ? ETaraflarArasiIliskiler.NEUTRAL : relation,
  //   );

  //   if (vis_displayCasualityStatus || isForOverlappedPopup || isSitrepMode) {
  //     sidc = checkSIDCForStatus(
  //       sidc,
  //       (unit.insanZayiatOrani !== undefined && unit.insanZayiatOrani > 0) ||
  //         (unit.otonomZayiatOrani !== undefined && unit.otonomZayiatOrani > 0),
  //       unit.faaliyeti !== undefined && unit.faaliyeti === EFaaliyet.ETKISIZ,
  //     );
  //   }
  // }

  if (unit.unitType === 'hla' && 'forceIdentifier' in unit && unit.sidc) {
    sidc = getSIDCByHlaForceIdentifier(unit.sidc, unit.forceIdentifier || HLAForceIdentifierEnum.NEUTRAL);
  }

  if (unit.unitType === 'hla') {
    const symbol = new ms.Symbol(sidc, opts);

    return symbol;
  } else {
    const symbol = new ms.Symbol(sidc, {
      ...opts,
      iconColor:
        properTextColor(unit.taraf?.rengi || '') === '#000000'
          ? ms.ColorMode('#000', '#000', '#000', '#000', '#000')
          : ms.ColorMode('#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'),
      infoColor: ms.ColorMode('#000', '#000', '#000', '#000', '#000'),
      outlineColor: ms.ColorMode('#000', '#000', '#000', '#000', '#000'),
      frameColor: ms.ColorMode('#000', '#000', '#000', '#000', '#000'),
    });

    return symbol;
  }
};

function unitIconClassNameGenerator(
  unitId: number,
  additionalInfoBool: boolean,
  isShip: boolean,
  activeStatus: EtmenDurumu,
): string {
  let className = `unit-icon-${unitId}`;

  if (activeStatus === EtmenDurumu.PASIF) {
    className += ' icon-passive';
  }

  if (additionalInfoBool) className += ' map-unit-icons';
  else className += ' map-unit-icons-low-zoom';

  if (isShip) className += ' icon-ship';

  return className;
}

export const unitIconGenerator = async (unit: MapUnit, options: UnitIconGeneratorProps) => {
  try {
    await preloadMilsymbol();

    const { additionalInfoBool = true } = options;

    const isShip = isShipIcon(unit.etmenTuru?.sidc || '');

    const symbol = await unitSymbolGenerator(unit, options);

    const divIcon = L.divIcon({
      iconSize: [symbol.getSize().width, symbol.getSize().height],
      className: unitIconClassNameGenerator(unit.id, additionalInfoBool, isShip, EtmenDurumu.AKTIF),
      html: symbol.asCanvas(),
      iconAnchor: L.point(symbol.getAnchor().x, symbol.getAnchor().y),
    });

    return divIcon;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('UNIT DRAW ERROR', unit, error);
  }
  return null;
};

export const getAgentName = (unit?: MapUnit) => {
  if (unit) {
    const { algiDurumu, kisaIsim, id } = unit;

    switch (algiDurumu) {
      case EAlgiDurumu['Not Detected or Identified']:
        return '';

      case EAlgiDurumu['Identity Identified']:
      case EAlgiDurumu['Contact Loss']:
      case EAlgiDurumu.Self:
        return kisaIsim;

      default:
        return `Unknown_${id}`;
    }
  }
};

export const getAnyField = (unit: MapUnit, field: string) => {
  const { algiDurumu } = unit;

  switch (algiDurumu) {
    case EAlgiDurumu['Not Detected or Identified']:
      return '';

    case EAlgiDurumu['Identity Identified']:
    case EAlgiDurumu['Contact Loss']:
    case EAlgiDurumu.Self:
      return unit[field as keyof MapUnit];

    default:
      return `Unknown`;
  }
};

export const getPrototype = (unit: MapUnit) => {
  switch (unit.algiDurumu) {
    case EAlgiDurumu['Not Detected or Identified']:
      return '';

    case EAlgiDurumu['Prototype Identified']:
    case EAlgiDurumu['Prototype and Side Identified']:
    case EAlgiDurumu['Identity Identified']:
    case EAlgiDurumu['Contact Loss']:
    case EAlgiDurumu.Self:
      return unit.etmenTuru?.kisaIsim || 'Unknown';

    default:
      return `Unknown`;
  }
};

export const getSide = (unit: MapUnit) => {
  switch (unit.algiDurumu) {
    case EAlgiDurumu['Not Detected or Identified']:
      return '';
    case EAlgiDurumu['Side Identified']:
    case EAlgiDurumu['Prototype and Side Identified']:
    case EAlgiDurumu['Identity Identified']:
    case EAlgiDurumu['Contact Loss']:
    case EAlgiDurumu.Self:
      return unit.taraf?.kisaIsim || 'Unknown';

    default:
      return `Unknown`;
  }
};

export const getSubOrdinates = (unit: MapUnit, units: MapUnit[], set: Set<number | bigint>) => {
  units
    .filter((o) => o.ustIsletenEtmenVtId === unit.id)
    .forEach((element) => {
      set.add(element.id);
      getSubOrdinates(element, units, set);
    });
};

export const isUnitDetected = (algiDurumu: EAlgiDurumu) => algiDurumu > EAlgiDurumu['Not Detected or Identified'];

export const isUnitFromOwnApp = (eklentiId: number) => eklentiId === 0;

export const isAirIcon = (sidc: string = '') => sidc.substring(4, 6) === SIDC_AIR_SYMBOL;

export const isAirMissileIcon = (sidc: string = '') => sidc.substring(4, 6) === SIDC_AIR_MISSILE_SYMBOL;

export const isLandIcon = (sidc: string = '') => sidc.substring(4, 6) === SIDC_LAND_SYMBOL;

export const isCivilianIcon = (sidc: string = '') => sidc.substring(4, 6) === SIDC_CIVILIAN_SYMBOL;

export const isShipIcon = (sidc: string = '') => sidc.substring(4, 6) === SIDC_SURFACE_SYMBOL;

export const isTorpedo = (sidc: string = '') => sidc.substring(4, 6) === SIDC_SUBSURFACE_SYMBOL;

export const isSubmarineIcon = (sidc = '') => sidc.substring(4, 6) === SIDC_SUBSURFACE_SYMBOL;

export const isNavalIcon = (sidc: string = '') =>
  [SIDC_SURFACE_SYMBOL, SIDC_SUBSURFACE_SYMBOL].includes(sidc.substring(4, 6));

export const isMineIcon = (sidc = '') => sidc.substring(4, 6) === SIDC_MINE_SYMBOL;

export const prototypeIsCivil = (sembolu: number = 0) => sembolu >= 10000 && sembolu < 20000;

export const prototypeIsLand = (sembolu: number = 0) =>
  (sembolu >= 30000 && sembolu < 40000) || prototypeIsNavalBase(sembolu) || prototypeIsAirBase(sembolu);

export const prototypeIsAir = (sembolu: number = 0) =>
  sembolu >= 40000 && sembolu < 50000 && !prototypeIsAirBase(sembolu);

export const prototypeIsNaval = (sembolu: number = 0) =>
  ((sembolu >= 50000 && sembolu < 60000) || prototypeIsCivilianShip(sembolu)) && !prototypeIsNavalBase(sembolu);

export const prototypeIsNavalBase = (sembolu: number = 0) => sembolu === 50003;

export const prototypeIsAirBase = (sembolu: number = 0) => sembolu === 40005;

export const prototypeIsCivilianShip = (sembolu: number = 0) => sembolu === 10016;

export const prototypeIsSpace = (sembolu: number = 0) => sembolu >= 60000;

export const prototypeIsSubmarine = (sembolu: number = 0) => sembolu === 50001;

const obstacles = [20003, 30015, 40003, 50002];
export const prototypeIsObstacle = (sembolu: number = 0) => obstacles.includes(sembolu);
